import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { BlogGridComponent } from './components/pages/blog-grid/blog-grid.component';
import { BlogRightSidebarComponent } from './components/pages/blog-right-sidebar/blog-right-sidebar.component';
import { CartPageComponent } from './components/pages/cart-page/cart-page.component';
import { CheckoutPageComponent } from './components/pages/checkout-page/checkout-page.component';
import { ComingSoonPageComponent } from './components/pages/coming-soon-page/coming-soon-page.component';
import { ContactPageComponent } from './components/pages/contact-page/contact-page.component';
import { CustomerServicePageComponent } from './components/pages/customer-service-page/customer-service-page.component';
import { FaqPageComponent } from './components/pages/faq-page/faq-page.component';
import { GalleryPageComponent } from './components/pages/gallery-page/gallery-page.component';
import { HomeDemoOneComponent } from './components/pages/home-demo-one/home-demo-one.component';
import { HomeDemoThreeComponent } from './components/pages/home-demo-three/home-demo-three.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { MyAccountPageComponent } from './components/pages/my-account-page/my-account-page.component';
import { NotFoundPageComponent } from './components/pages/not-found-page/not-found-page.component';
import { OrderTrackingPageComponent } from './components/pages/order-tracking-page/order-tracking-page.component';
import { RoomsPageComponent } from './components/pages/rooms-page/rooms-page.component';
import { ShopFullWidthPageOneComponent } from './components/pages/shop-full-width-page-one/shop-full-width-page-one.component';
import { ShopFullWidthPageTwoComponent } from './components/pages/shop-full-width-page-two/shop-full-width-page-two.component';
import { ShopLeftSidebarPageOneComponent } from './components/pages/shop-left-sidebar-page-one/shop-left-sidebar-page-one.component';
import { ShopLeftSidebarPageTwoComponent } from './components/pages/shop-left-sidebar-page-two/shop-left-sidebar-page-two.component';
import { ShopRightSidebarPageOneComponent } from './components/pages/shop-right-sidebar-page-one/shop-right-sidebar-page-one.component';
import { ShopRightSidebarPageTwoComponent } from './components/pages/shop-right-sidebar-page-two/shop-right-sidebar-page-two.component';
import { SimpleProductPageComponent } from './components/pages/simple-product-page/simple-product-page.component';
import { SliderProductPageComponent } from './components/pages/slider-product-page/slider-product-page.component';
import { StickyProductPageComponent } from './components/pages/sticky-product-page/sticky-product-page.component';
import { WishlistPageComponent } from './components/pages/wishlist-page/wishlist-page.component';
import { BedroomProductsComponent } from './components/pages/rooms-page/bedroom-products/bedroom-products.component';
import { AddPostComponent } from './components/pages/add-post/add-post.component';
import { ViewAllPostsComponent } from './components/pages/view-all-posts/view-all-posts.component';
import { EditPostComponent } from './components/pages/edit-post/edit-post.component';
import { EditOtherPostDetailsComponent } from './components/pages/edit-other-post-details/edit-other-post-details.component';
import { ViewAllPostByUserComponent } from './components/pages/view-all-post-by-user/view-all-post-by-user.component';
import { ViewPostDetailsByUserComponent } from './components/pages/view-post-details-by-user/view-post-details-by-user.component';



const routes: Routes = [
    {path: '', component: HomeDemoTwoComponent},
    {path: 'product/:itemKeyword', component: SimpleProductPageComponent}, //Used Components Start
    {path: 'all-products', component: SliderProductPageComponent},
    {path: 'search-product/:searchtext', component: StickyProductPageComponent},
    {path: 'contact', component: ContactPageComponent},
    {path: 'news', component: FaqPageComponent},
    {path: 'search', component: CartPageComponent},
    {path: 'warrenty', component: OrderTrackingPageComponent},
    {path: 'dealers-list', component: WishlistPageComponent},
    {path:'posts',component:ViewAllPostByUserComponent},
    {path:'post/:keywords',component:ViewPostDetailsByUserComponent},

    {path: 'admin/login', component: ShopRightSidebarPageOneComponent},
    {path: 'admin/home', component: HomeDemoThreeComponent},
    {path: 'admin/add-news', component: MyAccountPageComponent},
    {path: 'admin/view-all-news', component: ShopLeftSidebarPageOneComponent},
    {path:'admin/edit-news/:newsId',component:ShopLeftSidebarPageTwoComponent},
   
    {path:'admin/add-post',component:AddPostComponent},
    {path:'admin/view-all-posts',component:ViewAllPostsComponent},
    {path:'admin/edit-post/:keywords',component:EditPostComponent},
    {path:'admin/edit-other-post-details/:id',component:EditOtherPostDetailsComponent},

    {path: 'admin/add-product', component: ShopFullWidthPageOneComponent},
    {path:'admin/view-all-products',component:BedroomProductsComponent},
    {path:'admin/simple-product-edit/:itemKeywords',component:ShopFullWidthPageTwoComponent},
   
    /*{path: '', component: HomeDemoOneComponent},
    {path: 'index-2', component: HomeDemoTwoComponent},*/
   
    {path: 'about', component: AboutPageComponent},
    {path: 'shop', component: ShopFullWidthPageOneComponent},
    
    //{path: 'shop-left-sidebar-2', component: ShopLeftSidebarPageTwoComponent},
   
    {path: 'shop-right-sidebar-2', component: ShopRightSidebarPageTwoComponent},
    {path: 'rooms', component: RoomsPageComponent},
    {path: 'customer-service', component: CustomerServicePageComponent},
    {path: 'order-tracking', component: OrderTrackingPageComponent},
    {path: 'gallery', component: GalleryPageComponent},
    {path: 'checkout', component: CheckoutPageComponent},
    {path: 'wishlist', component: WishlistPageComponent},
    {path: 'blog-grid', component: BlogGridComponent},
    {path: 'blog-right-sidebar', component: BlogRightSidebarComponent},
    {path: 'blog-details', component: BlogDetailsComponent},
    {path: 'coming-soon', component: ComingSoonPageComponent},


  
    
    // Here add new pages component

    {path: '**', component: NotFoundPageComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }